<script setup lang="ts">
import { onMounted, provide } from "vue";
import MInputNumber from "./MInputNumber.vue";

const rules = [() => "Custom 1", () => "Custom 2", () => "Custom 3"];
const actions = [{ label: "Action 1" }, { label: "Action 2" }];
const validationController = [] as { validation: Function }[];

onMounted(() => {
  validationController.forEach((x) => x.validation());
});

provide("validationController", validationController);
</script>
<template>
  <div class="flex flex-col gap-3 q-ma-md">
    <m-input-number label="Input" />
    <m-input-number label="Input with helper" helper="Helper test" />
    <m-input-number label="Input with helper + required" helper="Helper test" required />
    <m-input-number label="Description" description="Input description" />
    <m-input-number label="Placeholder" placeholder="Placeholder" />
    <m-input-number label="with suffix">
      <template #append>kg</template>
    </m-input-number>

    <!--     TODO, build in decimals, with limits & can be negative -->
    <h2>Decimals</h2>

    <m-input-number
      label="With decimals"
      max-number-length="10"
      decimal-places="4"
      model-value="10.00"
    />

    <m-input-number
      label="With decimals"
      max-number-length="10"
      decimal-places="4"
      model-value="0.001"
      :pad="false"
    />

    <m-input-number
      label="With decimals"
      max-number-length="10"
      decimal-places="4"
      model-value=""
      :pad="false"
    />

    <h2>Pad numbers</h2>
    <m-input-number
      label="Pad number"
      max-number-length="5"
      model-value=""
      :pad="true"
      instructions="Pad numbers with zeros up to the max number length"
    />

    <h2>Min and Max values</h2>
    <m-input-number
      label="Min value"
      max-number-length="5"
      model-value="1000"
      min="1000"
      instructions="Should have a min value of 1000"
    />

    <m-input-number
      label="Min value"
      max-number-length="5"
      model-value="100"
      min="1000"
      instructions="Should have a min value of 1000"
    />

    <m-input-number
      label="Min decimal value"
      max-number-length="5"
      model-value="0.0001"
      min="0.001"
    />

    <m-input-number
      label="Max value"
      max-number-length="5"
      model-value="100"
      max="1000"
      instructions="Should have a max value of 1000"
    />

    <m-input-number
      label="Min negative value"
      max-number-length="5"
      model-value="-500"
      min="-200"
      instructions="Should have a min value of 1000"
    />

    <m-input-number
      label="Max negative value"
      max-number-length="5"
      model-value="-100"
      max="-200"
      instructions="Should have a max value of 1000"
    />

    <m-input-number
      label="Max value"
      max-number-length="5"
      model-value="1001"
      max="1000"
      instructions="Should have a max value of 1001"
    />
    <hr />
    <h2>Horizontal</h2>
    <m-input-number label="Horizontal" horizontal />
    <m-input-number
      label="Horizontal with description"
      description="horizontal description"
      horizontal
    />
    <m-input-number label="Horizontal width:200px" horizontal label-width="200px" />
    <m-input-number label="Horizontal with suffix" horizontal>
      <template #append>kg</template>
    </m-input-number>

    <m-input-number
      label="Horizontal width:200px + description"
      description="horizontal description"
      horizontal
      label-width="200px"
    />

    <m-input-number label="Required" required />
    <m-input-number label="Required Text" required required-text="custom field required" />
    <m-input-number label="Disable" disable />

    <m-input-number label="Rules" model-value="9" :rules="rules" />
    <m-input-number label="Rules show All errors" model-value="33" :rules="rules" show-all-errors />

    <m-input-number label="Actions" :actions="actions" />

    <m-input-number label="Actions left" :actions="actions" actions-left />

    <m-input-number label="Actions Horizontal" horizontal :actions="actions" />

    <m-input-number
      label="Value should be ignored"
      model-value="1"
      value="Not the correct value, this should not be showing, please reject change"
    />
    <m-input-number label="Suffix" model-value="5" suffix="Suffix" />
    <m-input-number label="Prepend" model-value="11">
      <template #prepend>Prepend</template>
    </m-input-number>

    <m-input-number label="small" small />
    <m-input-number label="medium" medium />
    <m-input-number label="large" large />

    <m-input-number label="No border" :border="false" model-value="7" />
  </div>
</template>
